import type { AttachesItem } from 'reactApp/modules/attaches/attaches.types';
import type { CloudFile } from 'reactApp/modules/storage/storage.types';

export const enum MenuItemName {
    OPEN_IN_MY = 'openinmy',
    OPEN_IN_PARENT = 'openinparent',
    COPY = 'copy',
    MOVE = 'move',
    MAIL = 'mail',
    FAVORITE = 'favorite',
    PRINT = 'print',
    RENAME = 'rename',
    DELETE = 'delete',
    COMPLAIN = 'complain',
    // tempexp_18663-next-line
    SHOW_PUBLIC_INFO = 'publicinfo',
    SHARE = 'share',
    DOWNLOAD = 'download',
}

export interface MenuItem {
    name: MenuItemName;
    active?: boolean;
    divider?: boolean;
    onClick?: (file: CloudFile | AttachesItem) => void;
}
